import { render, staticRenderFns } from "./FormsLayout.vue?vue&type=template&id=4c5c54be&scoped=true&"
import script from "./FormsLayout.vue?vue&type=script&lang=ts&"
export * from "./FormsLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5c54be",
  null
  
)

export default component.exports